export const FRACTIONAL_INPUT_LISTS = [
  {
    value: 'orgIdFractions',
    label: 'Org overrides',
  },
  {
    value: 'projectIdFractions',
    label: 'Project overrides',
  },
];

export const INPUT_LISTS = [
  {
    value: 'enabledOrgIds',
    label: 'Enabled orgs',
  },
  {
    value: 'enabledProjectIds',
    label: 'Enabled projects',
  },
  {
    value: 'disabledOrgIds',
    label: 'Disabled orgs',
  },
  {
    value: 'disabledProjectIds',
    label: 'Disabled projects',
  },
];
